import React, { useContext } from "react";
import "../../assets/css/layout.css";
import Topbar from "../menus/Topbar";
import LeftNavbar from "../menus/LeftNavbar";
import { Outlet } from "react-router-dom";
import AuthContext from "../../helpers/AuthContext";
import Login from "../login";
import { ErrorBoundary } from "react-error-boundary";

const ErrorFallback = ({ error, resetErrorBoundary }) => (
  <div
    style={{ padding: "20px", textAlign: "center", color: "red" }}
    className="p-0 m-0">
    <h2>Something went wrong! 😞</h2>
    <p>{error.message}</p>
    <button onClick={resetErrorBoundary}>Try Again</button>
  </div>
);

const Layout = ({ children }) => {
  const { authTokens, logoutUser } = useContext(AuthContext);
  return (
    // <ErrorBoundary
    //   FallbackComponent={ErrorFallback}
    //   onReset={
    //     logoutUser // Reload the page on reset
    //   }>
    <>
      {authTokens ? (
        <div style={{ display: "flex", height: "100vh" }} className="p-0 m-0">
          <LeftNavbar />
          <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
            <Topbar />
            <main style={{ flex: 1, padding: "0px" }}>
              {children} {/* Renders the nested route component */}
            </main>
          </div>
        </div>
      ) : (
        <Login />
      )}
      {/* </ErrorBoundary> */}
    </>
  );
};

export default Layout;